// src/persistentStorage/iconsContentDB.ts
import {
  Stringified,
  ionicStorageClass,
} from "@/persistentStorage/ionicStorageClass";

/**
 * Conteúdo dos ícones, endereçado pelo caminho do manifesto.
 * Chave:  "icons2/arrows/chevron_up.svg"
 * Valor:  data URI em base64, pronto para <img src>
 */
class IconsContentDB extends ionicStorageClass {
  async get(path: string): Promise<string | null> {
    await this.ready;
    const value = await this.getDatabaseItem(path);
    return (value as string) ?? null;
  }

  async put(path: string, dataUri: string): Promise<void> {
    await this.ready;
    await this.setDatabaseItem(path, dataUri as Stringified<string>);
  }

  async remove(path: string): Promise<void> {
    await this.ready;
    await this.removeDatabaseItem(path);
  }

  async keys(): Promise<string[]> {
    await this.ready;
    return this.keysDatabase();
  }

  async count(): Promise<number> {
    await this.ready;
    return this.countDatabaseItems();
  }

  async clearAll(): Promise<void> {
    await this.ready;
    await this.clearDatabase();
  }
}

export const iconsContentDB = new IconsContentDB(
  "icons-content",
  "icons-content-db",
);
